import styled from 'styled-components/macro';

export const ScFieldExpiryDateRow = styled.div<{ $list?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $list }) =>
    $list ? `repeat(1, 1fr)` : `repeat(2, 1fr)`};
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`;

export const ScShortAmount = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -2px;
  & > * {
    margin: 8px 2px 0;
    font-size: 12px;
  }
`;

export const ScCryptoBlock = styled.div`
  font-size: 14px;
  .details {
    margin: 16px 0;
  }
  .wallet {
    font-size: 16px;
    font-weight: 700;
  }
`;
